import axiosPost from "./axiosPost";

export const RNHTituloUpd = async (credentials, data) => {
    const body = {
        service: "RNHTituloUpd",
        params: {
            rnhTituloId: data?.id,
            rnhTituloCod: data?.cod,
            rnhTituloNombre: data?.name,
            rnhTituloVersion: data?.version,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
